import React from 'react';
import AmgenDrugCheckListInput from './controls/AmgenDrugCheckListInput';
import Attest from './controls/Attest';
import CheckListInput from './controls/CheckListInput';
import DateInput from './controls/DateInput';
import EmailInput from './controls/EmailInput';
import GenetechHubPharmacyInput from './controls/GenetechHubPharmacyInput';
import GoodDaysFormularySelectInput from './controls/GoodDaysFormularySelectInput';
import HealthWellFundMedications from './controls/HealthWellFundMedications';
import HealthWellFundSelectInput from './controls/HealthWellFundSelectInput';
import HtmlMarkdown from './controls/HtmlMarkdown';
import IntegerInput from './controls/IntegerInput';
import Markdown from './controls/Markdown';
import MoneyInput from './controls/MoneyInput';
import NumericInput from './controls/NumericInput';
import PhoneInput from './controls/PhoneInput';
import RadioGroupListInput from './controls/RadioGroupListInput';
import RadioInput from './controls/RadioInput';
import SelectInput from './controls/SelectInput';
import SignatureInput from './controls/SignatureInput';
import SingleCheckboxInput from './controls/SingleCheckboxInput';
import SsnInput from './controls/SsnInput';
import SsnLastFourInput from './controls/SsnLastFourInput';
import StateSelectInput from './controls/StateSelectInput';
import TextAreaInput from './controls/TextAreaInput';
import TextInput from './controls/TextInput';
import ZipInput from './controls/ZipInput';
import CancerCareFundSelectInput from './controls/CancerCareFundSelectInput';
import CancerCareFundMedications from './controls/CancerCareFundMedications';
import PANFundMedications from './controls/PANFundMedications';
import PANFundSelectInput from './controls/PANFundSelectInput';
import PAFFundSelectInput from './controls/PAFFundSelectInput';
import LLSFundSelectInput from './controls/LLSFundSelectInput';
import { maxSqlDate, minSqlDate } from '../Helpers/Calculations';
import TAFFundSelectInput from './controls/TAFFundSelectInput';
import TAFFundMedications from './controls/TAFFundMedications';
import { getDayjs } from '../Helpers/TimeFunctions';

const FormControl = props => {
    const { def, dataKey } = props;
    const ctlKey = `${dataKey}_ctl`;
    //const divKey = `${dataKey}_div`;

    let minDateFunc = () => minSqlDate;
    let maxDateFunc = () => maxSqlDate;

    switch (def.type) {
        case 'attest':
            return <Attest key={ctlKey} {...props} />;

        case 'checklist':
            return <CheckListInput key={ctlKey} {...props} />;

        case 'date':
            return <DateInput key={ctlKey} {...{ ...props, minDateFunc: minDateFunc, maxDateFunc: maxDateFunc }} />;

        case 'dateWithMaxToday':
            maxDateFunc = () => getDayjs(new Date(new Date().setHours(23, 59, 59, 0))).toDate();
            return <DateInput key={ctlKey} {...{ ...props, minDateFunc: minDateFunc, maxDateFunc: maxDateFunc }} />;
        case 'dateWithMaxYesterday':
            maxDateFunc = () => getDayjs(new Date(new Date().setHours(23, 59, 59, 0))).subtract(1, "day").toDate();
            return <DateInput key={ctlKey} {...{ ...props, minDateFunc: minDateFunc, maxDateFunc: maxDateFunc }} />;
        case 'email':
            return <EmailInput key={ctlKey} {...props} />;

        case 'html':
            return <HtmlMarkdown key={ctlKey} {...props} />;

        case 'integer-text':
        case 'integer':
            return <IntegerInput key={ctlKey} {...props} />;

        case 'markdown':
            return <Markdown key={ctlKey} {...props} />;

        case 'money':
        case 'currency':
        case 'currency-dollars':
            return <MoneyInput key={ctlKey} {...props} />;

        case 'number':
            return <NumericInput key={ctlKey} {...props} />;

        case 'radio':
        case 'radio-vertical':
            return <RadioInput key={ctlKey} {...props} />;

        case 'radiogrouplist':
            return <RadioGroupListInput key={ctlKey} {...props} />;

        case 'select':
        case 'dropdown':
            return <SelectInput key={ctlKey} {...props} />;

        case 'signature':
            return <SignatureInput key={ctlKey} {...props} />;

        case 'ssn':
            return <SsnInput key={ctlKey} {...props} />;

        case 'ssn-lastfour':
            return <SsnLastFourInput key={ctlKey} {...props} />;

        case 'states':
        case 'usstates':
            return <StateSelectInput key={ctlKey} {...props} />;

        case 'text':
        case 'string':
            return <TextInput key={ctlKey} {...props} />;

        case 'textarea':
            return <TextAreaInput key={ctlKey} {...props} />;

        case 'phone':
        case 'usphone':
            return <PhoneInput key={ctlKey} {...props} />;

        case 'zip':
            return <ZipInput key={ctlKey} {...props} />;

        //special cases go here
        case 'amgendrugchecklist':
            return <AmgenDrugCheckListInput key={ctlKey} {...props} />;

        case 'dropdownlist-gooddays-Treatment':
            return <GoodDaysFormularySelectInput key={ctlKey} {...props} />;

        case 'genentechHubPharmacy':
            return <GenetechHubPharmacyInput key={ctlKey} {...props} />;

        case 'healthwellfundselector':
            return <HealthWellFundSelectInput key={ctlKey} {...props} />;

        case 'healthwellmedications':
            return <HealthWellFundMedications key={ctlKey} {...props} />;

        case 'cancercarefundselector':
            return <CancerCareFundSelectInput key={ctlKey} {...props} />;

        case 'cancercaremedications':
            return <CancerCareFundMedications key={ctlKey} {...props} />;
        case 'panfundselector':
            return <PANFundSelectInput key={ctlKey} {...props}/>;
        case 'panmedications':
            return <PANFundMedications key={ctlKey} {...props}/>
        case 'llsfundselector':
            return <LLSFundSelectInput key={ctlKey} {...props}/>;
        case 'paffundselector':
            return <PAFFundSelectInput key={ctlKey} {...props}/>;
        case 'taffundselector':
            return <TAFFundSelectInput key={ctlKey} {...props}/>;
        case 'tafmedications':
            return <TAFFundMedications key={ctlKey} {...props}/>;
        case 'checkbox':
            return <SingleCheckboxInput key={ctlKey} {...props} />;

        default:
            return <div>???</div>;
    }
}

export default FormControl;
